import {requestGet} from '@/utils/request';

const api = {
    LIST: '/op/message_list',
    STAT: '/op/message_stat',
    CONVERSATION_USERS: '/op/message_conversation_users',
}

export async function messageList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function messageStat() {
    return requestGet(api.STAT);
}

export async function messageConversationUsers(queryParams) {
    return requestGet(api.CONVERSATION_USERS, queryParams);
}
